import React from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import CustomPaginationformoh from '../custompagination/CustomPagination';
import CustomPagination from '../custompagination/CustomPagination';
import './DataTable.css';

const DataTableReact = ({
  loading = false,
  data,
  columns,
  renderRowActions,
  page,
  Pagination,
  nextPageUrl,
  totalRows,
  prevPageUrl,
  setRowsPerPage,
  setPage,
  rowsPerPage,
  shouldShowActions = false,
  idetifyer = 'check',
}) => {
  // const [page, setPage] = React.useState(1); // Current page
  // const [rowsPerPage, setRowsPerPage] = React.useState(10); // Rows per page
  const user = JSON.parse(localStorage.getItem('user'));

  console.log(
    'sbckasbckabc',
    idetifyer === 'announcment' && user.role === 'physician_management'
  );

  // Handle rows per page change
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    // Adjust the page if it exceeds the new total pages
    const totalPages = Math.ceil(data.length / newRowsPerPage);
    if (page > totalPages) {
      setPage(totalPages);
    }
  };

  // Calculate the starting index for the current page
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  // // Slice the data based on the current page
  // const paginatedData = data?.slice(startIndex, endIndex);
  const table = useMaterialReactTable({
    columns,
    data,

    enableColumnActions: false,
    enableColumnResizing: shouldShowActions,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableRowActions: shouldShowActions,
    enableSorting: false,
    renderRowActions,
    enablePagination: false,
    positionActionsColumn: shouldShowActions ? 'last' : false,
    state: { isLoading: loading },

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor:
          row?.original?.physician?.actionStatus === 'blocked'
            ? '#FDEDF0'
            : 'transparent',
        display: 'flex',
        flexWrap: 'nowrap',
        '& > td:last-child': {
          display: 'none', // 👈 Hide last td if no actions
        },
      },
    }),
    muiTableHeadProps: {
      sx: {
        display: 'flex',
        'align-items': 'center',
        'align-self': 'stretch',
        'background-color': '#F6F8FA !important',
        // width: "fit-content",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        display: 'flex',
        flexGrow: 1, // Expands to fill available space
        flexBasis: '0%', // Ensures equal width distribution
        minWidth: '128px', // Minimum width constraint
        height: '48px',
        padding: '12px 12px 12px 12px',
        alignItems: 'center',
        gap: '12px',
      },
    },
    muiTableProps: {
      sx: {
        width: '100',
      },
    },

    muiTableHeadRowProps: {
      sx: {
        'box-shadow': 'none',
        width: '100%',
        display: 'flex',
        flexWrap: 'nowrap',
        '& > th:last-child': {
          display: 'none', // 👈 Hide extra th if no actions
        },
      },
    },
    muiTableHeadCellProps: {
      sx: {
        display: 'flex',
        flexGrow: 1, // Allows columns to expand
        flexBasis: '0%', // Distributes width evenly
        minWidth: '128px', // Minimum width constraint
        padding: '8px 12px',
        alignItems: 'center',
        gap: '10px',
        color: '#525866',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '20px',
        backgroundColor: '#F6F8FA !important',
        border: 'none',
      },
    },
  });
  return (
    <div>
      <MaterialReactTable table={table} />

      <CustomPaginationformoh
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalRows={totalRows}
      />
    </div>
  );
};

export default DataTableReact;

// defaultColumn={{
//       minSize: 20, //allow columns to get smaller than default
//       maxSize: 9001, //allow columns to get larger than default
//       size: 100, //make columns wider by default
//     }}
